import React from "react";
import {FiFile, FiFileText, FiGrid, FiImage, FiMusic, FiVideo} from "react-icons/fi";

export const getFileTypeInfo = (mimeType, fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();

    // Image types
    if (mimeType.startsWith('image/')) {
        return {
            color: 'text-purple-600',
            icon: <FiImage className="h-4 w-4"/>,
            type: 'image',
            previewable: true
        };
    }

    // PDF files
    if (mimeType.includes('pdf')) {
        return {
            color: 'text-red-600',
            icon: <FiFileText className="h-4 w-4"/>,
            type: 'pdf',
            previewable: true
        };
    }

    // Excel files
    if (mimeType.includes('spreadsheet') || mimeType.includes('excel') ||
        ['xlsx', 'xls', 'csv'].includes(extension)) {
        return {
            color: 'text-green-600',
            icon: <FiGrid className="h-4 w-4"/>,
            type: 'spreadsheet',
            previewable: false
        };
    }

    // Word documents
    if (mimeType.includes('word') || mimeType.includes('document') ||
        ['doc', 'docx', 'txt', 'rtf'].includes(extension)) {
        return {
            color: 'text-blue-600',
            icon: <FiFileText className="h-4 w-4"/>,
            type: 'document',
            previewable: false
        };
    }

    // Video files
    if (mimeType.startsWith('video/') ||
        ['mp4', 'avi', 'mov', 'wmv'].includes(extension)) {
        return {
            color: 'text-pink-600',
            icon: <FiVideo className="h-4 w-4"/>,
            type: 'video',
            previewable: true
        };
    }

    // Audio files
    if (mimeType.startsWith('audio/') ||
        ['mp3', 'wav', 'ogg'].includes(extension)) {
        return {
            color: 'text-yellow-600',
            icon: <FiMusic className="h-4 w-4"/>,
            type: 'audio',
            previewable: true
        };
    }

    // Default file type
    return {
        color: 'text-gray-600',
        icon: <FiFile className="h-4 w-4"/>,
        type: 'other',
        previewable: false
    };
};


export const FilePreview = ({attachment}) => {
    const {type, previewable} = getFileTypeInfo(attachment.file_type, attachment.original_name);

    if (!previewable) return null;

    switch (type) {
        case 'image':
            return (
                <div
                    className="w-full h-[100px] cursor-pointer"
                    onClick={() => handlePreview(attachment)}
                >
                    <img
                        src={`/storage/${attachment.file_path}`}
                        alt={attachment.original_name}
                        className="w-full h-full object-cover rounded-lg"
                    />
                </div>
            );
        case 'pdf':
            return (
                <iframe
                    src={`/storage/${attachment.file_path}`}
                    className="w-full h-[100px] rounded-lg"
                    title={attachment.original_name}
                />
            );
        case 'video':
            return (
                <video
                    src={`/storage/${attachment.file_path}`}
                    className="w-full h-[100px] rounded-lg"
                    controls
                />
            );
        case 'audio':
            return (
                <audio
                    src={`/storage/${attachment.file_path}`}
                    className="w-full"
                    controls
                />
            );
        default:
            return null;
    }
};
